import React, { useState, useContext } from "react";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

// import CrudRequisa from "./Requisas/CrudRequisa/CrudRequisa";

const ListadoRequisasMaterialesEnc = ({
  listadoEnc,
  //   loading,
  setIngresoEdit,
  setShowDialog,
  selectedDetalle,
  setSelectedDetalle,
}) => {
  const { userAuth } = useContext(AuthContext);
  const [hiddenIT, setHiddenIT] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(12)
  );

  const columns = [
    {
      field: "IdRequisaEnc",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      body: (rowData) => rowData.IdRequisaEnc,
      frozen: "frozen",
      hidden: hiddenIT,
    },
    {
      field: "FechaEncCreacion",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      body: (rowData) => rowData.FechaEnc,
      align: "center",
      Format: "DateTime",
      frozen: "frozen",
    },
    {
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.Requisa);
      },
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      body: (rowData) => rowData.Area,
    },
    {
      field: "UserNameSolicita",
      header: "Usuario Solicita",
      headerEn: "User Request",
      className: "small",
      body: (rowData) => rowData.UserNameSolicita,
    },
    {
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "small",
    },
    {
      field: "Comentarios",
      header: "Comentario",
      headerEn: "Comment",
      className: "small",
      flex: 1,
      body: (rowData) => rowData.Comentarios,
    },
    // {
    //   field: "UserNameCreate",
    //   header: "Usuario Creación",
    //   headerEn: "User Creation",
    //   className: "small",
    //   body: (rowData) => rowData.UserNameCreate,
    // },
    {
      field: "UsuarioEdit",
      header: "Usuario Edición",
      headerEn: "User Edition",
      className: "small",
      body: (rowData) => rowData.UsuarioEdit,
    },
    // {
    //   field: "IdTecnico",
    //   header: "IdTecnico",
    //   headerEn: "IdTecnico",
    //   className: "colum-width-Xlarge",
    //   body: (rowData) => rowData.IdTecnico,
    // },
  ];

  const table = {
    Columns: columns,
    Data: listadoEnc,
    fileName: "Ingresos Bodega" + new Date().toDateString(),
    // loading: loading,
    clases: "tablaListados alturaListado60",
    showModal: (e) => showModal(e),
    key: "IdRequisaEnc",
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  const showModal = () => {
    setShowDialog(true);
  };

  const Ingreso = (Id) => {
    setIngresoEdit(Id);
    setShowDialog(true);
  };

  return (
    <div>
      <div style={{ height: "83vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoRequisasMaterialesEnc;
